<template>
    <div>
        <div style="display: flex;">
            <router-link :to="`/admin/${type}/new`">
                <el-button type="primary" size="mini">Add New</el-button>
            </router-link>
        </div>
        <el-table :data="tableData" stripe style="width: 100%">
            <el-table-column prop="id" label="id">
            </el-table-column>
            <el-table-column v-for="attribute in attributes" :prop="attribute" :label="attribute">
            </el-table-column>
            <el-table-column width="120">
                <template slot-scope="scope">
                    <router-link :to="`/admin/${type}/${scope.row.id}`">
                        <el-button type="text" size="small">Edit</el-button>
                    </router-link>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    data() {
        return {
            type: 'projects',
            attributes: [],
            tableData: [
                { email: '' }
            ]
        }
    },
    mounted() {
        this.$store.dispatch(`${this.type}/loadAll`, {
          options: {
            'page[size]': '100',
          },
        }).then(() => {
            const items = this.$store.getters[`${this.type}/all`];
            this.attributes = Object.keys(items[0].attributes);
            this.tableData = items;
        });
    },
    methods: {

    }
}
</script>
